import { Component, computed, effect, inject, Input } from '@angular/core';
import { ResponseModel } from '../../generic-vaccination.model';
import { AllMaterialsStoreData } from 'src/app/modules/core/store/materials.signal.store';
import { AllMaterialModel } from 'src/app/modules/shared/models/common.model';
import { CommonStoreData } from 'src/app/modules/core/store/common.signal.store';
import { VaccinatedInfoStoreData } from '../../vaccinated-info.signal.store';
import moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-material-dose',
  templateUrl: './material-dose.component.html',
})
export class MaterialDoseComponent {
  @Input() doseNo: number = 1;
  @Input() isPrecautionDose: boolean = false;
  @Input() material: ResponseModel = null;
  @Input() isCurrentVaccination: boolean = true;
  @Input() materialInfo: AllMaterialModel = null;
  readonly allMaterialsStore = inject(AllMaterialsStoreData);
  readonly vaccinatedInfoStore = inject(VaccinatedInfoStoreData);
  readonly commonStore = inject(CommonStoreData);

  constructor() {}

  getMinDoseDate = computed(() => {
    if (this.vaccinatedInfoStore.benfData()) {
      let minDate = new Date(this.vaccinatedInfoStore.benfData()?.dob);
      if (
        this.vaccinatedInfoStore.benfData().ben_type_id ==
          environment.static_ids.PregnantWomen ||
        (this.vaccinatedInfoStore.benfData()?.lmc_date &&
          this.vaccinatedInfoStore.benfData().is_pregnant_woman)
      ) {
        minDate = new Date(this.vaccinatedInfoStore.benfData().lmc_date);
      }
      return minDate;
    }
  });

  getMaxDoseDate = computed(() => {
    if (this.vaccinatedInfoStore.benfData()) {
      let maxDate = new Date(
        moment(this.vaccinatedInfoStore.benfData()?.date_of_session)
          .subtract('days', 1)
          .format('YYYY-MM-DD')
      );
      if (
        this.vaccinatedInfoStore.benfData().ben_type_id ==
          environment.static_ids.PregnantWomen ||
        (this.vaccinatedInfoStore.benfData()?.lmc_date &&
          this.vaccinatedInfoStore.benfData().is_pregnant_woman)
      ) {
        maxDate = new Date(
          moment
            .utc(this.vaccinatedInfoStore.benfData().lmc_date)
            .add(9, 'months')
            .add(7, 'days')
            .format('YYYY-MM-DD')
        );
      }
      return maxDate;
    }
  });

  isEligible(): boolean {
    let doseReceived = this.doseReceived(this.doseNo);
    if (doseReceived) return false;
    if (!doseReceived && this.doseNo === 1) return true;
    if (!doseReceived && this.doseNo > 1) {
      const lastVaccData = this.doseReceived(this.doseNo - 1);
      return lastVaccData ? true : false;
    }
  }

  doseReceived(doseNo) {
    if (this.materialInfo) {
      return this.vaccinatedInfoStore.benfVaccinatedInfo().find((m) => {
        if (this.isPrecautionDose) {
          return (
            m?.material_id == this.materialInfo?.material_id &&
            m?.dose == doseNo &&
            m.is_precaution
          );
        }
        return (
          m?.material_id == this.materialInfo?.material_id &&
          m?.dose == doseNo &&
          !m.is_precaution
        );
      });
    }
    return null;
  }

  getVaccinationDate() {
    const doseReceivedInfo = this.doseReceived(this.doseNo);
    if (doseReceivedInfo) {
      return doseReceivedInfo.vaccination_date ?? null;
    }
    return null;
  }

  get doseName() {
    if (!this.materialInfo) {
      return null;
    }
    const materialDoseInfo = this.materialInfo;
    // console.log(materialDoseInfo);
    if (this.isPrecautionDose) {
      return materialDoseInfo.display_precaution_dose_names[this.doseNo - 1];
    }
    return materialDoseInfo.display_dose_names[this.doseNo - 1];
  }

  get doseInfo() {
    return {
      doseName: this.doseName,
      doseNo: this.doseNo,
      isPastDated: !this.isCurrentVaccination,
      isPrecautionDose: this.isPrecautionDose,
      vaccination_date: null,
      material_id: this.materialInfo.material_id,
    };
  }
}
